import React from "react";
import { tickerItems } from "../mock";

export default function Ticker() {
  const items = [...tickerItems, ...tickerItems];
  return (
    <div className="bg-neutral-900 border-y border-orange-500/20 overflow-hidden">
      <div className="ticker-track py-4">
        {items.map((t, i) => (
          <span key={i} className="inline-flex items-center px-8 text-white font-display text-lg md:text-xl tracking-wider uppercase">
            {t}
            <span className="mx-8 inline-block w-2 h-2 rounded-full bg-orange-500" />
          </span>
        ))}
      </div>
    </div>
  );
}
